import React, { useState } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextField from "@mui/material/TextField";
import { StyledDatePicker } from "../view-audit/StyledDatePicker";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setLoading } from "../store/feedback";
import { setSearchedDate } from "../store/images";
import { LinearProgress, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import HighlightAltIcon from "@mui/icons-material/HighlightAlt";
import CustomPaginationActionsTable from "./ViewTable";
import "../components/createAudit.css";
function ViewAuditHolder() {
	const dispatch = useDispatch();
	const { searchedDate } = useSelector((state) => state.imagesStore);
	const { loading } = useSelector((state) => state.feedbackStore);
	const [data, setData] = useState([]);
	const [loaded, setLoaded] = useState(false);

	const handleDateChange = async (newDate) => {
		console.log(newDate);
		const formattedDate = moment(newDate).format("YYYY-MM-DD");
		console.log(formattedDate);
		dispatch(setSearchedDate(formattedDate));
		dispatch(setLoading(true));
		try {
			const result = await axios.post("/create_audit/view_audit", {
				date: formattedDate,
			});
			console.log(result);
			setData(result.data);
			setLoaded(true);
			dispatch(setLoading(false));
		} catch (err) {
			console.log(err);
			dispatch(setLoading(false));
		}
	};
	return (
		<div style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			width: '80vw',
			height: '100svh',
		}}>
			{loading && <LinearProgress style={{ marginTop: 0 }} />}
				<div style={{ height: "100svh",width:"80%" }}>
					<div
						style={{
							position: "relative",
							top: 0,
							width: "100%",
							maxWidth: "100%",
							zIndex: 1000,
						}}
					>
						
					</div>
					<div
						style={{
							width: "100%",
							position: "relative",
							top: "1rem",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexDirection: "column",
						}}
					>
						<LocalizationProvider dateAdapter={AdapterMoment}>
							<StyledDatePicker
								sx={{
									width: "15rem",
									boxSizing: "border-box",
									paddingTop: "0.2em",
									borderRadius: "15px",
								}}
								value={moment(searchedDate)}
								onChange={(newDate) => handleDateChange(newDate)}
								renderInput={(params) => (
									<TextField
										variant="outlined"
										size="small"
										{...params}
										style={{ padding: "0.1rem 0", color: "white" }}
										className="text-field"
									/>
								)}
								format="YYYY-MM-DD"
							/>
						</LocalizationProvider>
						<div style={{ width: "calc(100vw - 4rem)" }}>
							{data.length > 0 ? (
								<CustomPaginationActionsTable data={data} />
							) : (
								loaded && (
									<Typography
										style={{
											fontSize: "0.9rem",
											textAlign: "center",
											margin: "1rem",
										}}
									>
										No data
									</Typography>
								)
							)}
						</div>
					</div>
				</div>
			</div>
	)
}

export default ViewAuditHolder